// extracted by mini-css-extract-plugin
export default {"label":"Label__label___pE682"};